module.exports = __webpack_public_path__ + "static/media/only.3e5633e4.meteor";